import React from "react";

const hr = () => <hr className="my-0 mx-2 py-0"/>;

export default hr



// WEBPACK FOOTER //
// ./src/components/components/hr/hr.js